import Container from "Components/Container/Container";
import React from "react";
import { Link } from "react-router-dom";

const Hero = ({ title }) => {
  return (
    <section className="normal-section-80 pt-32 pb-12 lg:pb-0 lg:pt-0">
      <Container className="h-full flex flex-col justify-center">
        <div>
          <h1 className="title">Academy</h1>
        </div>
        <div className="text-xl text-font flex flex-wrap items-center gap-x-2">
          <Link className="hover:underline" to={"/"}>
            Home{" "}
          </Link>
          <span>|</span>
          <Link className="hover:underline" to={"/academy"}>
            Academy
          </Link>
          <span>|</span>
          <Link
            className="hover:underline"
            to={{
              pathname: "/academy",
              search: `?category=${"trainings-and-workshops"}`,
            }}
          >
            Training & workshop{" "}
          </Link>
          <span>|</span>
          <p>{title}</p>
        </div>
      </Container>
    </section>
  );
};

export default Hero;
